
import { queryDateConfig } from '@/service';
/**
 * state(类似存储全局变量的数据)
 * getters(提供用来获取state数据的方法)
 * actions(提供跟后台接口打交道的方法， 并调用mutations提供的方法)
 * mutations(提供存储设置state数据的方法)
 */
let state = {
  timePeriod: [],//时间段枚举
}
let getters = {
  timePeriod: state => {
    return state.timePeriod.map(item => {
      return {
        value: item.cfgCode,
        label: item.cfgName,
        minValue: item.minValue,
        maxValue: item.maxValue,
      }
    })
  },
}
let mutations = {
  setTimePeriod(state, val) {
    state.timePeriod = val
  },
}
let actions = {
  getTimePeriod(context) {
    queryDateConfig({ cfgCategory: 'PERIOD' }).then((res) => {
      if (res.data) {
        context.commit('setTimePeriod', res.data);
      }
    }).catch((res) => {
      this.$message.error(res.message)
    })
  },
}
export default {
  namespaced: true, // namespaced 属性，限定命名空间
  state,
  getters,
  mutations,
  actions
}